<template>
    <div class="container-xl full-width-overflow">
        <div class="description-section">
            <div class="container-image">
                <img class="image-logo" src="/images/logo-pec-pec.png" alt="logo" />
             </div>
            <div class="wrapper-description">
                <div class="wrapper-description-image col-md-12 col-lg-6">
                    <div class="container-image-fura">
                        <img class="image-fura" src="/images/fura.jpg" alt="fura" />
                    </div>
                </div>
                <div class="wrapper-description-block container-xl">
                    <div class="description-block">
                        <div class="description-block-text">
                            <h2 v-dompurify-html="title.text" class="title-description"></h2>
                        </div>
                        <div v-for="(itemDescription, index) in htmlDescription" :key="index" v-dompurify-html="itemDescription.text" class="description-text" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{ data: { text: Element; type: string }[] }>();
const title = computed(() => props.data.find(el => el.type === 'title'));
const htmlDescription = computed(() => props.data.filter(el => el.type === 'text'));
</script>

<style lang="scss" scoped>
.full-width-overflow {
    overflow: hidden;
}

.description-section {
    margin-top: 7.5rem;
    margin-bottom: 4.5rem;
}

.wrapper-description-block {
    flex: 0 0 auto;
    width: 50%;
}

.description-block {
    display: flex;
    flex-direction: column;
}

.description-block-text {
    gap: 1.5rem;
}

.wrapper-description{
    display: flex;
    flex-direction: row-reverse;
}

.title-description {
    color: var(--brand-red-e-4003-c, #e4003c);
    font-family: Roboto;
    font-size: 2.25rem;
    font-style: normal;
    font-weight: 600;
    line-height: 2.875rem; /* 127.778% */
}

.description-text {
    color: var(--main-black-2-b-2-b-2-b, #2b2b2b);

    /* secondary/light/22-34 */
    font-family: Roboto;
    font-size: 1.375rem;
    font-style: normal;
    font-weight: 300;
    line-height: 2.125rem; /* 154.545% */
}

.description-text::v-deep(b) {
    font-weight: 700;
}

.wrapper-description-image {
    flex: 0 0 auto;
    width: 50%;
}
.container-image {
    padding: 0 16px;
}


@media (max-width: 1279px) {
    .wrapper-description {
        display: flex;
        flex-direction: column;
    }

    .wrapper-description-image {
        flex: 0 0 auto;
        width: 100%;
    }

    .container-image-fura {
        display: flex;
        justify-content: flex-end;
    }

    .wrapper-description-block {
        flex: 0 0 auto;
        width: 100%;
    }


}

@media (max-width: 991px) {
    .image-fura {
        max-width: 100%;
        margin-top: 24px;
        min-width: 492px;
    }
}

@media (max-width: 991px) {
    .title-description {
        font-weight: 600;
        font-size: 26px;
        line-height: 3px;
    }
}

@media (max-width: 768px) {
    .container-image {
        display: flex;
        justify-content: flex-start;
    }

    .image-logo {
        max-width: 282px;
    }

    .description-section {
        margin-top: 80px;
        margin-bottom: 60px;
    }

    .title-description {
        font-weight: 600;
        font-size: 26px;
        line-height: 36px;
        margin: 24px 0;
    }
}

@media (max-width: 480px) {
    .container-image {
        max-width: 282px;
        display: flex;
        justify-content: flex-start;
    }

    .description-section {
        margin-top: 40px;
    }
    .container-image-fura {
        display: flex;
        justify-content: flex-start;
    }
    .image-fura {
        max-width: 100%;
        margin-top: 24px;
        min-width: 492px;
    }

}



</style>
